const pagesPeopleSettingsEn = {
  shared: {
    editDisplayOrder: "Edit display order",
    actionsColumn: {
      disableButton: "Deactivate",
      enableButton: "Activate",
      deleteButton: "Delete",
    },
    DeleteDialog: {
      title: "Delete {{name}}?",
      description:
        "If you use {{name}}, you cannot delete master name. This operation cannot be undone.",
      cancelButton: "Cancel",
      permanentlyDeleteButton: "Permanently Delete",
    },
    DisableDialog: {
      title: "Deactivate {{name}}?",
      description:
        "If you deactivate {{name}}, you will not use it anymore. The data will not be deleted and can view it in past data. You can activate it again.",
      cancelButton: "Cancel",
      disableButton: "Deactivate",
    },
    EnableDialog: {
      title: "Activate {{name}}?",
      description:
        "If you activate {{name}}, you can use it again. The previously deactivated data will be restored to active status and available for use.",
      cancelButton: "Cancel",
      enableButton: "Activate",
    },
  },
  employmentTypes: {
    title: "Employment type",
    description:
      "A classification that indicates the type of employee's labor contract and work style, and includes different employment forms such as full-time, part-time, contract employee, and part-time job.",
    addEmploymentType: "Add employment type",
    editEmploymentType: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Full-time, Part-time",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "full-time, part-time",
      },
    },
  },
  boardMemberTypes: {
    title: "Board member type",
    description:
      "A classification that indicates the type of board member, and includes different types such as executive, non-executive, and external director.",
    addBoardMemberType: "Add board member type",
    editBoardMemberType: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "executive, auditor",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "executive, auditor",
      },
    },
  },
  contractorTypes: {
    title: "Contractor type",
    description:
      "A classification of individuals and corporations that perform work based on contracts with companies, and includes different types such as directors, outsourcers, external consultants, and outsourcers. ",
    addContractorType: "Add contractor type",
    editContractorType: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Director, Partner, Temporary",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "director, partner, temporary",
      },
    },
  },
  collaboratorTypes: {
    title: "Collaborator type",
    description:
      "Outside collaborators are individuals and corporations that are not employees or contractors of the organization. They can be used to customer representatives or something like that.",
    addCollaboratorType: "Add collaborator type",
    editCollaboratorType: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Customer Representative, Head Office Representative",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "C01, C02",
      },
    },
  },
  positions: {
    title: "Position",
    description:
      "This is a classification that indicates the job content and scope of responsibilities of employees and executives. Job titles can be expressed by department, or by positions such as CEO or CTO that are not tied to a department.",
    addPosition: "Add position",
    editPosition: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "CEO, Manager",
      },
      rank: {
        label: "Rank",
        placeholder: "1",
        description:
          "Rank represents the hierarchical relationship between positions.",
        helpText:
          "Rank can be used as a condition for various rules, such as app assignment rule.",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "ceo, mgr",
      },
    },
  },
  jobTitles: {
    title: "Job title",
    description:
      "A classification that indicates an employee's position or position, and includes different positions such as general manager, section manager, supervisor, and staff. ",
    addJobTitle: "Add job title",
    editJobTitle: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Manager",
      },
      rank: {
        label: "Rank",
        placeholder: "1",
        description:
          "Rank represents the hierarchical relationship between job titles.",
        helpText:
          "Rank can be used as a condition for various rules, such as app assignment rule.",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "manager",
      },
    },
  },
  grades: {
    title: "Grade",
    description:
      "A classification that indicates a hierarchy based on the evaluation and role of each employee. It can be used to express salary ranges, etc.",
    addGrade: "Add grade",
    editGrade: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "A1, B3, C2",
      },
      rank: {
        label: "Rank",
        placeholder: "1",
        description:
          "Rank represents the hierarchical relationship between grades.",
        helpText:
          "Rank can be used as a condition for various rules, such as app assignment rule.",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "a1, b3, c2",
      },
    },
  },
  jobCompetencies: {
    title: "Job competency",
    description:
      "Employee A grade that is set based on the skills and abilities an employee possesses. Job competency can be used to evaluate skill levels and job performance, and to express promotions and career paths.",
    addJobCompetency: "Add job competency",
    editJobCompetency: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Management, General",
      },
      rank: {
        label: "Rank",
        placeholder: "1",
        description:
          "Rank represents the hierarchical relationship between job competencies.",
        helpText:
          "Rank can be used as a condition for various rules, such as app assignment rule.",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "management, general",
      },
    },
  },
  jobGrades: {
    title: "Job grade",
    description:
      "This is a grade that is set according to the job content and responsibility of employees and contractors. Job grades are classified based on job title and scope of work, and can be used for purposes such as clarifying roles and their values within an organization.",
    addJobGrade: "Add job grade",
    editJobGrade: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Manager 1, Senior 3",
      },
      rank: {
        label: "Rank",
        placeholder: "1",
        description:
          "Rank represents the hierarchical relationship between job grades.",
        helpText:
          "Rank can be used as a condition for various rules, such as app assignment rule.",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "manager1, senior3",
      },
    },
  },
  jobTypes: {
    title: "Job type",
    description:
      "A classification that indicates the field or specialty of an employee or contractor, with each job category representing a specific skill set or knowledge. By registering sales positions, development positions, etc., you can use them for conditions of various rules.",
    addJobType: "Add job type",
    editJobType: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Sales, Engineer",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "sales, engineer",
      },
    },
  },
  jobFunctions: {
    title: "Job function",
    description:
      "This is a classification that indicates more detailed work content and task content that cannot be expressed by job title alone. Jobs specify the roles and scope of responsibilities within a job category, and can be used as indicators of work results and goal achievement.",
    addJobFunction: "Add job function",
    editJobFunction: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Backend engineer",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      jobType: {
        label: "Job type",
        placeholder: "Select job type...",
        searchPlaceholder: "Search job type...",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "backend-engineer",
      },
    },
  },
  jobLevels: {
    title: "Job level",
    description:
      "Job level refers to the hierarchical ranking of a specific job within an organization, indicating its scope, level of responsibility, and required expertise to earn. While often related to organizational structure and titles, it's not always a direct match.",
    addJobLevel: "Add job level",
    editJobLevel: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Senior (engineer)",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "senior",
      },
    },
  },
  workModes: {
    title: "Work mode",
    description:
      "Work arrangement refers to the terms and conditions under which an employee and contractor performs their job: for example, full-time, flextime, part-time and etc.",
    addWorkMode: "Add work mode",
    editWorkMode: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name, code...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Full-time, Part-time",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
      code: {
        label: "Code",
        description: "Code must be unique in your organization.",
        placeholder: "full-time, part-time",
      },
    },
  },
  contractEndReasons: {
    title: "Contract end reason",
    description:
      "A contract end reason indicates why a contractor's contract is ending. For example, project completion or personal request.",
    addContractEndReason: "Add contract end reason",
    editContractEndReason: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Project end",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
    },
  },
  retirementReasons: {
    title: "Retirement reason",
    description:
      "A retirement reason indicates why an employee is retiring. For example, mandatory retirement or voluntary resignation.",
    addRetirementReason: "Add retirement reason",
    editRetirementReason: "Edit {{name}}",
    showDeactivated: "Show only deactivated",
    searchPlaceholder: "Filter by name...",
    form: {
      name: {
        label: "Name",
        description: "Name should be unique in your organization.",
        placeholder: "Mandatory retirement",
      },
      displayOrder: {
        label: "Display order",
        description: {
          forAdd:
            "If you do not input display order, default value 0 will be set.",
        },
        placeholder: "1",
      },
    },
  },
  healthInsuranceAssociations: {
    title: "Health Insurance Association",
    description:
      "A classification of health insurance associations that employees join, including different insurance organizations such as the National Health Insurance Association and health insurance unions.",
    addHealthInsuranceAssociation: "Add health insurance association",
    editHealthInsuranceAssociation: "Edit {{name}}",
    dialog: {
      addTitle: "Add health insurance association",
      editTitle: "Edit health insurance association",
      form: {
        associationType: "Health insurance society type",
        associationTypePlaceholder:
          "National Health Insurance Association, Health Insurance Union",
        associationName: "Health insurance society name",
        associationNamePlaceholder:
          "National Health Insurance Association, Health Insurance Union",
      },
    },
  },
  placeSocialInsurances: {
    title: "Business Establishments",
    description: "Manage social insurance business establishments.",
    addPlaceSocialInsurance: "Add Business Establishment",
    columns: {
      businessEstablishment: "Business Establishment",
      address: "Address",
      representative: "Representative",
    },
    actions: {
      openMenu: "Open menu",
      viewDetails: "View Details",
      delete: "Delete",
    },
    dialog: {
      selectPlaceTitle: "Select Place",
      cannotSelectPlaceTitle: "No places available",
      selectPlaceDescription:
        "Select a place to add as a social insurance business establishment",
      cannotSelectPlaceDescription:
        "To register a new place, please click the 'Proceed to Add Place' button below.",
      loadingPlaces: "Loading places...",
      selectPlaceLabel: "Place",
      selectPlace: "Select Place",
      searchPlaceName: "Search Place Name",
      selectPlaceError: "Please select a place.",
      cancel: "Cancel",
      add: "Add",
      proceedToAddPlace: "Proceed to Add Place",
    },
  },
  employeeSubIdNames: {
    title: "Employee Sub ID",
    description:
      "The Employee Sub ID is used for identification, for example, in cases where a different ID is assigned at a subsidiary.",
    addEmployeeSubIdName: "Add Employee Sub ID",
    editEmployeeSubIdName: "Edit {{name}}",
    showDeactivated: "Show Deactivated Only",
    searchPlaceholder: "Search by name",
    form: {
      name: {
        label: "Name",
        description: "The name must be unique within the organization.",
        placeholder: "Partner Code",
      },
      displayOrder: {
        label: "Display Order",
        description: {
          forAdd:
            "If you do not enter a display order, the default value 0 will be set.",
        },
        placeholder: "1",
      },
    },
  },
};

export default pagesPeopleSettingsEn;
